var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: _vm.modalId,
      attrs: {
        id: _vm.modalId,
        title: "Adjuntar archivo desde el repositorio",
        "ok-title": "Vale",
        "data-cy": "save",
        size: "xl",
        "ok-only": ""
      },
      on: { ok: _vm.handleOk }
    },
    [
      _c(
        "div",
        [
          _c("MinimalDocumentManagement", {
            attrs: {
              "add-file": _vm.addFile,
              files: _vm.files,
              "show-principal-button": _vm.showPrincipalButton,
              "max-files": _vm.maxFiles
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }